'use strict';

(function () {
  var MenuToggler = $('.header__hamburger').click(function (e) {
    $(this).toggleClass('__js_isActive');
    $('.header__nav').toggleClass('__js_isActive');
  });
  $('.header__nav ul').on('click', function () {
    $('.header__hamburger').removeClass('__js_isActive');
    setTimeout(function () {
      $('.header__nav').removeClass('__js_isActive');
    }, 500);
  });
  // $('.header__nav ul').on('mouseleave', function () {
  //   $('.header__nav').removeClass('__js_isActive');
  //   $('.header__hamburger').removeClass('__js_isActive');
  // });
})();
